import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import AutoComplete from "components/Custom/AutoComplete";
import RadioBtn from "components/Custom/RadioBtn";
import TxtRow from "components/Custom/TxtRow";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import { FORMATS, NOTIFY } from "common/config";
import { LABELS, WARNINGS, TITLES, SUB_TITLES } from "common/lables";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";
import { COLORS } from "common/colors";

import { MASTER_APIs } from "apihandlers/master";
import { REPORTS_APIs } from "apihandlers/reports";

const BeatHitMiss = (props: any) => {
  const { setDashMenu } = props;

  const orgRef: any = useRef();

  const [loading, setLoading] = useState(true);
  const [masters, setMasters] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [isCombined, setIsCombined] = useState(false);
  const [columns, setColumns] = useState<any>([]);

  // Columns are in apihandler;
  //   const columns = [
  //     {
  //       key: "slNo",
  //       name: LABELS.SL_NO,
  //       width: "5%",
  //       type: "number",
  //       editable: false,
  //       sortable: true,
  //       searchable: true,
  //       align: "center",
  //       headerAlign: "center",
  //     },
  //     {
  //       key: "id",
  //       name: LABELS.ID,
  //       width: "5%",
  //       type: "number",
  //       editable: false,
  //       sortable: true,
  //       searchable: true,
  //       align: "center",
  //       headerAlign: "center",
  //     },
  //     //TODO: Please Check if this column is needed or not.
  //     // {
  //     //     key: "orgId",
  //     //     name: LABELS.DEALER,
  //     //     width: "5%",
  //     //     type: "number",
  //     //     editable: false,
  //     //     sortable: true,
  //     //     searchable: true,
  //     //     align: "center",
  //     //     headerAlign: "center",
  //     //   },
  //     {
  //       key: "dealerName",
  //       name: LABELS.DEALER_NAME,
  //       width: "20%",
  //       type: "text",
  //       editable: false,
  //       sortable: true,
  //       searchable: true,
  //       align: "center",
  //       headerAlign: "center",
  //     },
  //     {
  //       key: "city",
  //       name: LABELS.CITY,
  //       width: "10%",
  //       type: "text",
  //       editable: false,
  //       sortable: true,
  //       searchable: true,
  //       align: "center",
  //       headerAlign: "center",
  //     },
  //     {
  //       key: "state",
  //       name: LABELS.STATE,
  //       width: "10%",
  //       type: "text",
  //       editable: false,
  //       sortable: true,
  //       searchable: true,
  //       align: "center",
  //       headerAlign: "center",
  //     },
  //     isCombine &&{
  //       key: "asmName",
  //       name: LABELS.ASM_NAME,
  //       width: "20%",
  //       type: "text",
  //       editable: false,
  //       sortable: true,
  //       searchable: true,
  //       align: "center",
  //       headerAlign: "center",
  //     },
  //     {
  //       key: "rsmName",
  //       name: LABELS.RSM_NAME,
  //       width: "20%",
  //       type: "text",
  //       editable: false,
  //       sortable: true,
  //       searchable: true,
  //       align: "center",
  //       headerAlign: "center",
  //     },
  //     {
  //       key: "month",
  //       name: LABELS.MONTH,
  //       width: "10%",
  //       type: "number",
  //       editable: false,
  //       sortable: true,
  //       searchable: true,
  //       align: "center",
  //       headerAlign: "center",
  //     },
  //     {
  //       key: "year",
  //       name: LABELS.YEAR,
  //       width: "10%",
  //       type: "text",
  //       editable: false,
  //       sortable: true,
  //       searchable: true,
  //       align: "center",
  //       headerAlign: "center",
  //     },
  //     {
  //       key: "targetAmount",
  //       name: LABELS.TARGET_AMOUNT,
  //       width: "10%",
  //       type: "number",
  //       editable: false,
  //       sortable: true,
  //       searchable: true,
  //       align: "center",
  //       headerAlign: "center",
  //     },
  //     {
  //       key: "dayWiseTarget",
  //       name: LABELS.DAY_WISE_TARGET,
  //       width: "5%",
  //       type: "number",
  //       editable: false,
  //       sortable: true,
  //       searchable: true,
  //       align: "center",
  //       headerAlign: "center",
  //     },
  //     {
  //       key: "achivePercent",
  //       name: LABELS.ACHIEVE_PERCENT,
  //       width: "5%",
  //       type: "number",
  //       editable: false,
  //       sortable: true,
  //       searchable: true,
  //       align: "center",
  //       headerAlign: "center",
  //     },
  //     {
  //       key: "gap",
  //       name: LABELS.GAP,
  //       width: "5%",
  //       type: "number",
  //       editable: false,
  //       sortable: true,
  //       searchable: true,
  //       align: "center",
  //       headerAlign: "center",
  //     },
  //   ];

  useEffect(() => {
    if (loading) {
      getOrgProfile();
    }
  }, [loading]);

  const getOrgProfile = () => {
    const args = {
      minResponse: true,
    };
    MASTER_APIs.getOrgProfiles(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list: any = [{ id: -1, label: "All" }];
        let recs: any = response.records;
        for (let i = 0; i < recs.length; i++) {
          list.push({
            id: recs[i].id,
            label: recs[i].organizationName,
          });
        }
        setMasters(list);
        // setLoading(false);
      }
    });
  };

  const loadChart = () => {
    const orgId = orgRef.current.selectedValue.id;
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    const op = document.querySelector(
      'input[name="allCombined"]:checked'
    ) as HTMLInputElement;
    const allCombined = op ? op.value : "";

    const args = {
      fromDt,
      toDt,
      orgId,
      allCombined,
      reportType: "excel",
    };
    if (isCombined) {
      setIsCombined(true);
    }
    let errors = [];
    if (!orgId) {
      errors.push({
        id: "outlet",
        msg:
          "<span class='bold'>" +
          LABELS.OUTLET +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (fromDt === "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt === "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    setRows(null);
    // setLoading(true);
    REPORTS_APIs.getKPIRouteHitMiss(args).then((res) => {
      const { status, response } = res;
      if (status === 200) {
        for (let i = 0; i < response.rows.length; i++) {
          response.rows[i]["slNo"] = i + 1;
        }
        setRows(response.rows);
        setColumns(response.columns);
        setLoading(false);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    loadChart();
  };

  console.log("Page: Beat Hit Miss:");

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>{LABELS.KPI}</li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.BEAT_HIT_MISS}</li>
        </ul>
        <h4>{TITLES.BEAT_HIT_MISS}</h4>
        <p>{SUB_TITLES.BEAT_HIT_MISS}</p>
      </div>
      <div className="hChart">
        <div
          style={{ width: "100%", display: "flex", flexDirection: "column" }}
        >
          <div
            className="formGroup"
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: 5,
              marginBottom: 10,
              width: "40%",
            }}
          >
            <label>{LABELS.DEALER + " :"}</label>
            <AutoComplete
              id={"masters"}
              list={masters}
              childRef={orgRef}
              defaultValue={{ id: -1, label: "All" }}
            />
          </div>
        </div>

        <div className="flexRowJustify">
          <div className="formGroup width45" style={{ marginRight: "1rem" }}>
            <TxtRow
              id={"fromDt"}
              type={"date"}
              label={LABELS.FROM_DATE}
              defaultValue={DateFunctions.getDate(
                "from",
                "from",
                FORMATS.SQL_DATE_ONLY
              )}
            />
          </div>
          <div className="formGroup width45">
            <TxtRow
              id={"toDt"}
              type={"date"}
              label={LABELS.TO_DATE}
              defaultValue={DateFunctions.getDate(
                "thismonth",
                "to",
                FORMATS.SQL_DATE_ONLY
              )}
            />
          </div>
        </div>
        <div
          className="formGroup"
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: 5,
            marginBottom: 10,
            width: "60%",
          }}
        >
          <div>
            <label>{LABELS.OPTIONS}</label>
            <RadioBtn
              list={[
                {
                  id: "detailed",
                  value: "detailed",
                  label: LABELS.DETAILED,
                  checked: false,
                  disabled: false,
                },
                {
                  id: "dealerSummary",
                  value: "dealerSummary",
                  label: LABELS.DETAILED_SUMMARY,
                  checked: false,
                  disabled: false,
                },
                {
                  id: "dealerMonthlySummary",
                  value: "dealerMonthlySummary",
                  label: LABELS.DEALER_MONTHLY_SUMMARY,
                  checked: false,
                  disabled: false,
                },
                {
                  id: "sOMonthlySummary",
                  value: "sOMonthlySummary",
                  label: LABELS.SO_MONTHLY_SUMMARY,
                  checked: false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"allCombined"}
              // disabled={isSubmit}
            />
          </div>

          <div
            style={{
              display: "flex",
              padding: 17,
              marginTop: "0.3rem",
            }}
          >
            <Btn
              text={LABELS.LOAD}
              onClick={loadChart}
              bgColor={COLORS.SAVE_GREEN}
            />
          </div>
        </div>

        {mandatoryResults.length > 0 && (
          <div className="mandatoryBox">
            <ul>
              {mandatoryResults.map((m) => {
                return (
                  <li>
                    <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        <div className="grid excelGridWrapper">
          {!loading &&
            (rows ? (
              <ExcelGrid
                id={"beatHitMiss"}
                height={window.innerHeight * 0.5}
                cols={columns}
                rows={rows}
                exportOption={true}
                newRowOption={false}
                exportName={LABELS.BEAT_HIT_MISS}
                onReload={reloadGrid}
              />
            ) : (
              <div className="flexCenter" style={{ minHeight: 450 }}>
                <Loader />
              </div>
            ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(BeatHitMiss);
